import React from 'react';
import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  Step2BuyCarConsentCustomerPopup
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={Step2BuyCarConsentCustomerPopup}
      content={CarleadHIWWhyChooseWkdaFaq}
      howItWorksShowCta={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
